(function () {
  'use strict';

  var NAME_MAX = 17;
  var NAME_FUELLWOERTER = /^(mit|und|&|-|\/|workshop|diy|kurs|design|wine|watercolour|limitiert|engl\.?)$/i;

  // Kürzt einen Workshop-Titel auf eine Zeile: Klammern und Zusätze nach " - " weg,
  // Füllwörter raus, dann Wörter von vorn, solange sie in NAME_MAX passen.
  // Kristin überschreibt das Ergebnis mit dem Metafeld custom.kalender_name.
  function kuerzeName(name) {
    if (typeof name !== 'string') {
      return '';
    }
    var n = name.replace(/\([^)]*\)/g, ' ').replace(/\s*[:\/]\s*/g, ' ');
    var teile = n.split(/\s+-\s*|\s*-\s+|\s+-$/);
    if (teile.length > 1 && /wine\s*&\s*design/i.test(teile[0])) {
      teile.shift();
    }
    n = teile[0] || n;
    var woerter = n.split(/\s+/).filter(function (w) {
      return w && !NAME_FUELLWOERTER.test(w);
    });
    if (!woerter.length) {
      woerter = n.split(/\s+/).filter(Boolean);
    }
    var out = '';
    for (var i = 0; i < woerter.length; i++) {
      var probe = out ? out + ' ' + woerter[i] : woerter[i];
      if (probe.length > NAME_MAX) {
        break;
      }
      out = probe;
    }
    if (out) {
      return out;
    }
    var erstes = woerter[0];
    if (erstes.indexOf('-') > 0) {
      var kandidaten = erstes.split('-').filter(function (t) {
        return t.length <= NAME_MAX;
      }).sort(function (a, b) {
        return b.length - a.length;
      });
      if (kandidaten.length) {
        return kandidaten[0];
      }
    }
    return erstes.slice(0, NAME_MAX - 1) + '.';
  }

  // Entfernt eine Versal-Überschrift am Anfang der Produktbeschreibung
  // ("ADVENTSKRÄNZE BINDEN ...") und kürzt auf etwa 22 Wörter.
  function bereinigeIntro(text) {
    if (typeof text !== 'string') {
      return '';
    }
    var t = text.replace(/\s+/g, ' ').trim();
    var m = t.match(/^([^a-zäöüß]{12,}?)(?=[A-ZÄÖÜ][a-zäöüß])/);
    if (m) {
      t = t.slice(m[1].length).replace(/^[\s!:.-]+/, '');
    }
    var woerter = t.split(' ');
    if (woerter.length > 22) {
      t = woerter.slice(0, 22).join(' ').replace(/[,;:\s-]+$/, '') + ' ...';
    }
    return t;
  }

  function parseDatum(str) {
    var parts = str.split('-');
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10) - 1;
    var d = parseInt(parts[2], 10);
    return new Date(y, m, d);
  }

  function formatiereDatumISO(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function formatiereMonatTitel(date) {
    var monat = new Intl.DateTimeFormat('de-DE', { month: 'long' }).format(date);
    var aktJahr = new Date().getFullYear();
    if (date.getFullYear() !== aktJahr) {
      return monat + ' ' + date.getFullYear();
    }
    return monat;
  }

  function formatiereZelleAria(date, count) {
    var d = date.getDate();
    var monat = new Intl.DateTimeFormat('de-DE', { month: 'long' }).format(date);
    var suffix = count === 1 ? ' Workshop' : ' Workshops';
    return d + '. ' + monat + ', ' + count + suffix;
  }

  function formatierePanelDatum(date) {
    return new Intl.DateTimeFormat('de-DE', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date);
  }

  function aggregiereTagesEintraege(datumStr, workshops, termine) {
    var eintraege = [];
    if (!termine || !workshops) {
      return eintraege;
    }
    for (var i = 0; i < workshops.length; i++) {
      var ws = workshops[i];
      var wsTermine = termine[ws.handle];
      if (!wsTermine) {
        continue;
      }
      var times = wsTermine[datumStr];
      if (!times || times.length === 0) {
        continue;
      }
      var maxFrei = 0;
      var maxGesamt = 0;
      var isKnapp = false;
      var allAusgebucht = true;
      for (var t = 0; t < times.length; t++) {
        var slot = times[t];
        if (slot.frei > maxFrei) {
          maxFrei = slot.frei;
        }
        if (slot.gesamt > maxGesamt) {
          maxGesamt = slot.gesamt;
        }
        if (slot.frei > 0) {
          allAusgebucht = false;
          if (slot.frei <= 2 || (slot.gesamt > 0 && (slot.frei / slot.gesamt) <= 0.25)) {
            isKnapp = true;
          }
        }
      }
      eintraege.push({
        handle: ws.handle,
        name: kuerzeName(ws.name),
        fullName: ws.name,
        title: ws.title,
        bild: ws.bild || '',
        intro: bereinigeIntro(ws.intro),
        url: ws.url,
        preis: ws.preis,
        dauer: ws.dauer || '',
        neu: !!ws.neu,
        bestseller: !!ws.bestseller,
        frei: maxFrei,
        gesamt: maxGesamt,
        knapp: isKnapp,
        ausgebucht: allAusgebucht,
        times: times
      });
    }
    return eintraege;
  }

  var RegiondoQuelle = {
    laden: function (workshops, config) {
      return new Promise(function (resolve) {
        if (!Array.isArray(workshops) || workshops.length === 0) {
          resolve({ termine: {}, fehler: 0, erfolge: 0 });
          return;
        }

        var widgetMap = {};
        var mapStorageKey = 'gg_rg_map';
        var mapMaxAge = 30 * 24 * 60 * 60 * 1000;

        try {
          var rawMap = localStorage.getItem(mapStorageKey);
          if (rawMap) {
            var parsedMap = JSON.parse(rawMap);
            if (parsedMap && typeof parsedMap === 'object' && typeof parsedMap.timestamp === 'number') {
              if (Date.now() - parsedMap.timestamp < mapMaxAge && parsedMap.data) {
                widgetMap = parsedMap.data;
              }
            }
          }
        } catch (e) {
        }

        var missingWidgetIds = [];
        var seenWidgets = {};
        for (var i = 0; i < workshops.length; i++) {
          var wId = workshops[i].widgetId;
          if (wId && !widgetMap[wId] && !seenWidgets[wId]) {
            seenWidgets[wId] = true;
            missingWidgetIds.push(wId);
          }
        }

        var widgetBase = (config && config.widgetApiBase ? config.widgetApiBase : '').replace(/\/+$/, '');
        var apiBase = (config && config.apiBase ? config.apiBase : '').replace(/\/+$/, '');
        var partnerCode = config && config.partnerCode ? config.partnerCode : '';
        var partnerDomain = config && config.partnerDomain ? config.partnerDomain : '';

        var widgetPromises = missingWidgetIds.map(function (widgetId) {
          var url = widgetBase + '/widgets/' + encodeURIComponent(widgetId) + '/configuration';
          return fetch(url, { mode: 'cors' })
            .then(function (res) {
              if (!res.ok) {
                throw new Error('Config fetch failed');
              }
              return res.json();
            })
            .then(function (data) {
              var pId = (data && data.settings && data.settings.productId) ? String(data.settings.productId) : null;
              return { widgetId: widgetId, productId: pId };
            });
        });

        Promise.allSettled(widgetPromises).then(function (widgetResults) {
          var mapUpdated = false;
          for (var j = 0; j < widgetResults.length; j++) {
            var res = widgetResults[j];
            if (res.status === 'fulfilled' && res.value && res.value.productId) {
              widgetMap[res.value.widgetId] = res.value.productId;
              mapUpdated = true;
            }
          }

          if (mapUpdated) {
            try {
              localStorage.setItem(mapStorageKey, JSON.stringify({
                timestamp: Date.now(),
                data: widgetMap
              }));
            } catch (e) {
            }
          }

          var sessionTimes = {};
          var timesStorageKey = 'gg_rg_times';
          var timesMaxAge = 30 * 60 * 1000;

          try {
            var rawTimes = sessionStorage.getItem(timesStorageKey);
            if (rawTimes) {
              var parsedTimes = JSON.parse(rawTimes);
              if (parsedTimes && typeof parsedTimes === 'object') {
                sessionTimes = parsedTimes;
              }
            }
          } catch (e) {
          }

          var productIdsToFetch = [];
          var seenProducts = {};

          for (var k = 0; k < workshops.length; k++) {
            var wsWidgetId = workshops[k].widgetId;
            var pId = wsWidgetId ? widgetMap[wsWidgetId] : null;
            if (pId && !seenProducts[pId]) {
              seenProducts[pId] = true;
              var cached = sessionTimes[pId];
              var isCacheValid = cached && typeof cached.timestamp === 'number' && (Date.now() - cached.timestamp < timesMaxAge);
              if (!isCacheValid) {
                productIdsToFetch.push(pId);
              }
            }
          }

          var timesPromises = productIdsToFetch.map(function (productId) {
            var url = apiBase + '/timeslots/times?productId=' + encodeURIComponent(productId);
            return fetch(url, {
              mode: 'cors',
              headers: {
                'x-locale': 'de-DE',
                'x-partner-code': partnerCode,
                'x-tenant': 'REGIONDO',
                'x-partner-domain': partnerDomain
              }
            })
              .then(function (res) {
                if (!res.ok) {
                  throw new Error('Timeslots fetch failed');
                }
                return res.json();
              })
              .then(function (data) {
                var daysObj = (data && data.days) ? data.days : {};
                var mappedDays = {};
                var dateKeys = Object.keys(daysObj);
                for (var d = 0; d < dateKeys.length; d++) {
                  var dk = dateKeys[d];
                  var tObj = (daysObj[dk] && daysObj[dk].times) ? daysObj[dk].times : {};
                  var timeList = [];
                  var tKeys = Object.keys(tObj);
                  for (var t = 0; t < tKeys.length; t++) {
                    var tk = tKeys[t];
                    var item = tObj[tk] || {};
                    var frei = typeof item.availableQuantity === 'number' ? item.availableQuantity : 0;
                    var gesamt = typeof item.capacity === 'number' ? item.capacity : 0;
                    timeList.push({
                      zeit: tk,
                      frei: frei,
                      gesamt: gesamt
                    });
                  }
                  timeList.sort(function (a, b) {
                    return a.zeit.localeCompare(b.zeit);
                  });
                  mappedDays[dk] = timeList;
                }
                return { productId: productId, days: mappedDays };
              });
          });

          Promise.allSettled(timesPromises).then(function (timesResults) {
            var timesUpdated = false;
            for (var r = 0; r < timesResults.length; r++) {
              var tr = timesResults[r];
              if (tr.status === 'fulfilled' && tr.value && tr.value.days) {
                sessionTimes[tr.value.productId] = {
                  timestamp: Date.now(),
                  days: tr.value.days
                };
                timesUpdated = true;
              }
            }

            if (timesUpdated) {
              try {
                sessionStorage.setItem(timesStorageKey, JSON.stringify(sessionTimes));
              } catch (e) {
              }
            }

            var termine = {};
            var fehler = 0;
            var erfolge = 0;

            for (var w = 0; w < workshops.length; w++) {
              var ws = workshops[w];
              var prodId = ws.widgetId ? widgetMap[ws.widgetId] : null;
              if (!prodId) {
                fehler++;
                continue;
              }
              var prodTimesEntry = sessionTimes[prodId];
              if (prodTimesEntry && prodTimesEntry.days) {
                termine[ws.handle] = prodTimesEntry.days;
                erfolge++;
              } else {
                fehler++;
              }
            }

            resolve({
              termine: termine,
              fehler: fehler,
              erfolge: erfolge
            });
          });
        });
      });
    }
  };

  function initKalender(rootEl) {
    var sectionId = rootEl.dataset.sectionId;
    var monthsAhead = parseInt(rootEl.dataset.monthsAhead, 10) || 6;

    var scriptEl = document.getElementById('gg-kalender-data-' + sectionId);
    var workshops = [];
    if (scriptEl) {
      try {
        workshops = JSON.parse(scriptEl.textContent || '[]');
      } catch (e) {
        workshops = [];
      }
    }

    var monatSpan = rootEl.querySelector('[data-gg-monat]');
    var prevBtn = rootEl.querySelector('[data-gg-prev]');
    var nextBtn = rootEl.querySelector('[data-gg-next]');
    var statusEl = rootEl.querySelector('[data-gg-status]');
    var rasterEl = rootEl.querySelector('[data-gg-raster]');
    var panelEl = rootEl.querySelector('[data-gg-panel]');
    var fallbackEl = rootEl.querySelector('[data-gg-fallback]');
    var tplHerz = document.getElementById('gg-icon-herz-' + sectionId);
    var tplStern = document.getElementById('gg-icon-stern-' + sectionId);
    var tplKrone = document.getElementById('gg-icon-krone-' + sectionId);

    var now = new Date();
    var startMonat = new Date(now.getFullYear(), now.getMonth(), 1);
    var endMonat = new Date(now.getFullYear(), now.getMonth() + monthsAhead - 1, 1);
    var aktuellerMonat = new Date(startMonat.getTime());
    var termine = null;
    var auswahl = null;

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (aktuellerMonat > startMonat) {
          aktuellerMonat = new Date(aktuellerMonat.getFullYear(), aktuellerMonat.getMonth() - 1, 1);
          render();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (aktuellerMonat < endMonat) {
          aktuellerMonat = new Date(aktuellerMonat.getFullYear(), aktuellerMonat.getMonth() + 1, 1);
          render();
        }
      });
    }

    function selectDate(datumStr, handle) {
      auswahl = { datum: datumStr, handle: handle };
      renderPanel();
      renderGrid();
    }

    function renderPanel() {
      if (!panelEl) {
        return;
      }
      if (!auswahl) {
        panelEl.hidden = true;
        panelEl.textContent = '';
        return;
      }

      panelEl.textContent = '';
      panelEl.hidden = false;

      var kopf = document.createElement('div');
      kopf.className = 'gg-kal__panel-kopf';

      var heading = document.createElement('h3');
      heading.tabIndex = -1;
      var parsedDate = parseDatum(auswahl.datum);
      heading.textContent = formatierePanelDatum(parsedDate);
      kopf.appendChild(heading);

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'gg-kal__close';
      closeBtn.setAttribute('aria-label', 'Schließen');
      closeBtn.textContent = '×';
      closeBtn.addEventListener('click', function () {
        auswahl = null;
        panelEl.hidden = true;
        panelEl.textContent = '';
        renderGrid();
      });
      kopf.appendChild(closeBtn);
      panelEl.appendChild(kopf);

      var eintraege = aggregiereTagesEintraege(auswahl.datum, workshops, termine);

      if (auswahl.handle) {
        var resetWrap = document.createElement('div');
        resetWrap.className = 'gg-kal__filter-reset-wrap';
        var resetBtn = document.createElement('button');
        resetBtn.type = 'button';
        resetBtn.className = 'gg-kal__filter-reset';
        resetBtn.textContent = 'Alle Workshops an diesem Tag';
        resetBtn.addEventListener('click', function () {
          auswahl.handle = null;
          renderPanel();
        });
        resetWrap.appendChild(resetBtn);
        panelEl.appendChild(resetWrap);

        eintraege = eintraege.filter(function (e) {
          return e.handle === auswahl.handle;
        });
      }

      for (var i = 0; i < eintraege.length; i++) {
        var entry = eintraege[i];
        var article = document.createElement('article');
        article.className = 'gg-kal__eintrag';

        if (entry.bild) {
          var bildLink = document.createElement('a');
          bildLink.className = 'gg-kal__bild';
          bildLink.href = entry.url;
          bildLink.tabIndex = -1;
          bildLink.setAttribute('aria-hidden', 'true');
          var img = document.createElement('img');
          img.src = entry.bild;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 240;
          img.height = 240;
          bildLink.appendChild(img);
          article.appendChild(bildLink);
        }

        var body = document.createElement('div');
        body.className = 'gg-kal__eintrag-body';
        article.appendChild(body);

        // Langtitel am Desktop, Kurzname am Handy (Umschaltung per CSS)
        var h4 = document.createElement('h4');
        var lang = document.createElement('span');
        lang.className = 'gg-kal__titel-lang';
        lang.textContent = entry.title;
        var kurz = document.createElement('span');
        kurz.className = 'gg-kal__titel-kurz';
        kurz.textContent = entry.name;
        h4.appendChild(lang);
        h4.appendChild(kurz);
        body.appendChild(h4);

        if (entry.intro) {
          var introP = document.createElement('p');
          introP.className = 'gg-kal__intro';
          introP.textContent = entry.intro;
          body.appendChild(introP);
        }

        var ulZeiten = document.createElement('ul');
        ulZeiten.className = 'gg-kal__zeiten';

        for (var t = 0; t < entry.times.length; t++) {
          var slot = entry.times[t];
          var li = document.createElement('li');
          li.className = 'gg-kal__zeit';
          li.appendChild(document.createTextNode(slot.zeit + ' Uhr '));

          var freiSpan = document.createElement('span');
          freiSpan.className = 'gg-kal__frei';
          if (slot.frei === 0) {
            li.classList.add('gg-kal__zeit--ausgebucht');
            freiSpan.textContent = 'ausgebucht';
          } else {
            if (slot.frei === 1) {
              freiSpan.textContent = 'noch 1 Platz';
            } else {
              freiSpan.textContent = 'noch ' + slot.frei + ' Plätze';
            }
            if (slot.frei <= 2) {
              freiSpan.classList.add('gg-kal__frei--knapp');
            }
          }
          li.appendChild(freiSpan);
          ulZeiten.appendChild(li);
        }
        if (entry.dauer) {
          var dauerLi = document.createElement('li');
          dauerLi.className = 'gg-kal__zeit gg-kal__dauer';
          dauerLi.textContent = 'Dauer ' + entry.dauer;
          ulZeiten.appendChild(dauerLi);
        }
        body.appendChild(ulZeiten);

        var fuss = document.createElement('div');
        fuss.className = 'gg-kal__eintrag-fuss';
        body.appendChild(fuss);

        var preisP = document.createElement('p');
        preisP.className = 'gg-kal__preis';
        var preisFmt = entry.preis.toLocaleString('de-DE', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        });
        preisP.textContent = 'ab ' + preisFmt + ' \u20AC';
        fuss.appendChild(preisP);

        var bookLink = document.createElement('a');
        bookLink.className = 'btn btn--primary';
        bookLink.href = entry.url;
        bookLink.textContent = 'Zum Kurs';
        fuss.appendChild(bookLink);

        panelEl.appendChild(article);
      }

      panelEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      heading.focus({ preventScroll: true });
    }

    function renderGrid() {
      if (!rasterEl) {
        return;
      }
      rasterEl.textContent = '';

      var wochentage = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
      for (var w = 0; w < wochentage.length; w++) {
        var wtEl = document.createElement('div');
        wtEl.className = 'gg-kal__wt';
        wtEl.setAttribute('role', 'columnheader');
        wtEl.textContent = wochentage[w];
        rasterEl.appendChild(wtEl);
      }

      var heuteStr = formatiereDatumISO(new Date());
      var y = aktuellerMonat.getFullYear();
      var m = aktuellerMonat.getMonth();
      var firstDay = new Date(y, m, 1);
      var offset = (firstDay.getDay() + 6) % 7;
      var daysInMonth = new Date(y, m + 1, 0).getDate();

      for (var o = 0; o < offset; o++) {
        var emptyCell = document.createElement('div');
        emptyCell.className = 'gg-kal__zelle gg-kal__zelle--leer';
        rasterEl.appendChild(emptyCell);
      }

      for (var d = 1; d <= daysInMonth; d++) {
        var currentDate = new Date(y, m, d);
        var datumStr = formatiereDatumISO(currentDate);
        var cellEl = document.createElement('div');
        cellEl.className = 'gg-kal__zelle';
        cellEl.setAttribute('role', 'gridcell');
        if (datumStr < heuteStr) {
          cellEl.classList.add('gg-kal__zelle--vergangen');
        }

        if (auswahl && auswahl.datum === datumStr) {
          cellEl.classList.add('gg-kal__zelle--aktiv');
        }

        var eintraege = aggregiereTagesEintraege(datumStr, workshops, termine);
        var tagStr = String(d).padStart(2, '0');

        if (eintraege.length === 0) {
          var tagSpan = document.createElement('span');
          tagSpan.className = 'gg-kal__tag';
          tagSpan.textContent = tagStr;
          cellEl.appendChild(tagSpan);
        } else {
          var hatFreiePlaetze = eintraege.some(function (e) {
            return e.frei > 0;
          });
          if (hatFreiePlaetze) {
            cellEl.classList.add('gg-kal__zelle--gold');
          } else {
            cellEl.classList.add('gg-kal__zelle--voll');
          }

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'gg-kal__zelle-btn';
          btn.setAttribute('aria-label', formatiereZelleAria(currentDate, eintraege.length));

          var btnTagSpan = document.createElement('span');
          btnTagSpan.className = 'gg-kal__tag';
          btnTagSpan.textContent = tagStr;
          btn.appendChild(btnTagSpan);

          var spanNamen = document.createElement('span');
          spanNamen.className = 'gg-kal__namen';
          var maxNames = Math.min(eintraege.length, 3);
          for (var ni = 0; ni < maxNames; ni++) {
            var entry = eintraege[ni];
            var nameSpan = document.createElement('span');
            nameSpan.className = 'gg-kal__name';
            nameSpan.dataset.handle = entry.handle;
            nameSpan.textContent = entry.name;
            (function (h, dt) {
              nameSpan.addEventListener('click', function (evt) {
                evt.stopPropagation();
                selectDate(dt, h);
              });
            })(entry.handle, datumStr);
            spanNamen.appendChild(nameSpan);
          }
          if (eintraege.length > 3) {
            var mehrSpan = document.createElement('span');
            mehrSpan.className = 'gg-kal__mehr';
            mehrSpan.textContent = '+' + (eintraege.length - 3);
            spanNamen.appendChild(mehrSpan);
          }
          btn.appendChild(spanNamen);

          var spanPunkte = document.createElement('span');
          spanPunkte.className = 'gg-kal__punkte';
          var dotCount = Math.min(eintraege.length, 3);
          for (var p = 0; p < dotCount; p++) {
            var dot = document.createElement('i');
            spanPunkte.appendChild(dot);
          }
          btn.appendChild(spanPunkte);

          var hasKnapp = eintraege.some(function (e) {
            return e.knapp;
          });
          var hasNeu = eintraege.some(function (e) {
            return e.neu;
          });
          var hasBestseller = eintraege.some(function (e) {
            return e.bestseller;
          });

          if (hasKnapp || hasNeu || hasBestseller) {
            var spanIcons = document.createElement('span');
            spanIcons.className = 'gg-kal__icons';
            if (hasKnapp && tplHerz && tplHerz.content && tplHerz.content.firstElementChild) {
              spanIcons.appendChild(tplHerz.content.firstElementChild.cloneNode(true));
            }
            if (hasNeu && tplStern && tplStern.content && tplStern.content.firstElementChild) {
              spanIcons.appendChild(tplStern.content.firstElementChild.cloneNode(true));
            }
            if (hasBestseller && tplKrone && tplKrone.content && tplKrone.content.firstElementChild) {
              spanIcons.appendChild(tplKrone.content.firstElementChild.cloneNode(true));
            }
            btn.appendChild(spanIcons);
          }

          (function (dt) {
            btn.addEventListener('click', function () {
              selectDate(dt, null);
            });
          })(datumStr);

          cellEl.appendChild(btn);
        }

        rasterEl.appendChild(cellEl);
      }

      var rem = (offset + daysInMonth) % 7;
      if (rem !== 0) {
        var trailing = 7 - rem;
        for (var tr = 0; tr < trailing; tr++) {
          var trCell = document.createElement('div');
          trCell.className = 'gg-kal__zelle gg-kal__zelle--leer';
          rasterEl.appendChild(trCell);
        }
      }
    }

    function render() {
      if (monatSpan) {
        monatSpan.textContent = formatiereMonatTitel(aktuellerMonat);
      }
      if (prevBtn) {
        prevBtn.disabled = (aktuellerMonat.getFullYear() === startMonat.getFullYear() && aktuellerMonat.getMonth() === startMonat.getMonth());
      }
      if (nextBtn) {
        nextBtn.disabled = (aktuellerMonat.getFullYear() === endMonat.getFullYear() && aktuellerMonat.getMonth() === endMonat.getMonth());
      }
      renderGrid();
    }

    render();

    var config = {
      partnerCode: rootEl.dataset.partnerCode || 'GR167',
      partnerDomain: rootEl.dataset.partnerDomain || 'https://grimms-garten.regiondo.de/',
      apiBase: rootEl.dataset.apiBase || 'https://shopping-experience-api.prod.regiondo.net/api/v1',
      widgetApiBase: rootEl.dataset.widgetApiBase || 'https://partner-widgets-editor-backend.prod.regiondo.net/api/v1'
    };

    RegiondoQuelle.laden(workshops, config).then(function (res) {
      termine = res.termine;
      if (res.erfolge === 0) {
        if (statusEl) {
          statusEl.hidden = true;
        }
        if (fallbackEl) {
          fallbackEl.hidden = false;
        }
      } else {
        if (fallbackEl) {
          fallbackEl.hidden = true;
        }
        if (res.fehler > 0) {
          if (statusEl) {
            statusEl.textContent = 'Einige Termine konnten nicht geladen werden.';
            statusEl.hidden = false;
          }
        } else {
          if (statusEl) {
            statusEl.hidden = true;
          }
        }
        renderGrid();
        if (auswahl) {
          renderPanel();
        }
      }
    }).catch(function () {
      if (statusEl) {
        statusEl.hidden = true;
      }
      if (fallbackEl) {
        fallbackEl.hidden = false;
      }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.gg-kal');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].dataset.ggInitialised) {
        els[i].dataset.ggInitialised = 'true';
        initKalender(els[i]);
      }
    }
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt && evt.target) {
      initAll(evt.target);
    }
  });

  window.GGKalender = {
    RegiondoQuelle: RegiondoQuelle
  };
})();
